var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const forever = () => new Promise(() => { });
export const delay = (n) => __awaiter(void 0, void 0, void 0, function* () { return new Promise((resolve) => setTimeout(resolve, n)); });
export const konst = (x) => __awaiter(void 0, void 0, void 0, function* () { return x; });
export const konstPromise = konst;
export const mapPromise = (x, f) => __awaiter(void 0, void 0, void 0, function* () { return f(yield x); });
export const withPromise = (before, after, x) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        before();
        return yield x();
    }
    finally {
        after();
    }
});
